<div class="layout--margin-top spacing--margin-bottom">
  <agr-filter
    [config]="filterConfig"
    (dialogSaved)="filterDialogSaved($event)"
    [disableDefaultOnClear]="true"
    (clear)="resetFilters()"
    (alt)="restoreKpiSelection()"
    [infotext]="infotext$ | async"
  >
  </agr-filter>
  <agr-filter [config]="settingsConfig" [disableDefaultOnClear]="true"></agr-filter>
</div>
